import { BLUE, RED } from '@/constants/tagColors'

export const DOCUMENTS_STATUS_UPLOADED = { text: 'Загружено', color: BLUE }
export const DOCUMENTS_STATUS_NOT_UPLOADED = { text: 'Отсутствует', color: RED }

export const DOCUMENTS_STATUSES_GROUP = {
  true: DOCUMENTS_STATUS_UPLOADED,
  false: DOCUMENTS_STATUS_NOT_UPLOADED
}
